/**
 * @fileoverview PUT handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id/message/:message_variation_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../../../reactQueryFetcherAdapters";
import { appGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationIdCacheKeys } from "./constants";
import type { PutMessageProps, PutMessageResult } from "./types";

export const putMessage = reactQueryMutationAdapter(
  appGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationIdCacheKeys,
  ({ appGroupId, workflowId, stepId, messageVariationId, ...rest }: PutMessageProps): Promise<PutMessageResult> => {
    return fetch(
      `/${appGroupId}/canvas/${workflowId}/step/${stepId}/message/${messageVariationId}`,
      "PUT",
      rest,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
